export default __webpack_public_path__ + "static/media/ClinicAppointments.53ba0945.png";